import {useQueryParams} from '@aboutyou/router';

export const usePreviewSessionId = (): string | null => {
  const queryParams = useQueryParams();
  return queryParams.get('previewSessionId');
};
